import { useWSModalCustom } from "@wingspanhq/fe-component-library";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import { ModalRequirementHistory } from "../components/ModalRequirementHistory";
import { useRequirementHistoryResources } from "../hooks/useRequirementHistoryResources";

export const getRequirementHistoryWidget = (
  requirement: IRequirementResponse
) => {
  return <Widget requirement={requirement} />;
};

const Widget: React.FC<{ requirement: IRequirementResponse }> = ({
  requirement
}) => {
  const modal = useWSModalCustom(ModalRequirementHistory);
  const scope = useRequirementHistoryResources(requirement);

  return (
    <ResourceHistory
      resources={scope}
      onViewAll={() => {
        modal.open({ requirement });
      }}
    />
  );
};
